var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_vm._t("snackbar-content"),_c('layout-toolbar'),_c('layout-drawer'),_c('v-content',[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }